export default __webpack_public_path__ + "static/media/dance.1c884028.png";